module.exports = __webpack_public_path__ + "static/img/商务厅.b93e46c4.png";